import { CancelTokenSource } from 'axios';

import {
  ProposedShipment,
  CostEstimateResponse,
  GetRouteBuilderMapDetailsResponse,
} from '@/model/routeBuilder';
import { RoutePlanProposedShipment } from '@/model/routeBuilder/phase2';

import { BaseHttpController } from './BaseHttpController';

export class ShipmentPlanningController extends BaseHttpController {
  static readonly ENDPOINT: string = 'shipment-planning';

  constructor() {
    super(ShipmentPlanningController.ENDPOINT);
  }

  async findCostEstimate(
    proposedShipments: ProposedShipment[] | RoutePlanProposedShipment[],
  ): Promise<CostEstimateResponse> {
    const response = await this.http.post<CostEstimateResponse>(
      'cost-estimate',
      { proposedShipments },
    );

    return new CostEstimateResponse(response.data);
  }

  async getMapDetails(
    proposedShipments: ProposedShipment[] | RoutePlanProposedShipment[],
    cancelToken?: CancelTokenSource,
  ): Promise<GetRouteBuilderMapDetailsResponse> {
    const response = await this.http.post<GetRouteBuilderMapDetailsResponse>(
      'map-details',
      { proposedShipments },
      { cancelToken: cancelToken?.token },
    );

    return new GetRouteBuilderMapDetailsResponse(response.data);
  }
}
